var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.92138 3.1252L2.04638 15.0002C1.93685 15.1899 1.8791 15.4051 1.87891 15.6241C1.87871 15.8431 1.93608 16.0584 2.04527 16.2483C2.15446 16.4382 2.31164 16.5961 2.50105 16.7061C2.69046 16.8161 2.90546 16.8744 3.1245 16.8752H16.8745C17.0936 16.8744 17.3086 16.8161 17.498 16.7061C17.6874 16.5961 17.8445 16.4382 17.9537 16.2483C18.0629 16.0584 18.1203 15.8431 18.1201 15.6241C18.1199 15.4051 18.0622 15.1899 17.9526 15.0002L11.0776 3.1252C10.9689 2.93525 10.812 2.77739 10.6226 2.66761C10.4333 2.55782 10.2184 2.5 9.9995 2.5C9.78065 2.5 9.56569 2.55782 9.37636 2.66761C9.18704 2.77739 9.03008 2.93525 8.92138 3.1252V3.1252Z",
    stroke: "#1A181E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangle);
export default __webpack_public_path__ + "static/media/triangle.9058b8efd37bba7dc3d570927dd95440.svg";
export { ForwardRef as ReactComponent };